export { localeReducer, type LocaleState } from './locale';
